
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("fMc22", function(module, exports) {
"use strict";
var $b7c4ac00dd8a92a2$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Check = void 0;

const $b7c4ac00dd8a92a2$var$react_1 = $b7c4ac00dd8a92a2$var$__importDefault((parcelRequire("acw62")));
const $b7c4ac00dd8a92a2$var$Check = ({ fill: fill = "none" })=>{
    if (fill === "filled") return $b7c4ac00dd8a92a2$var$react_1.default.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 256 256",
        width: "100%",
        height: "100%"
    }, $b7c4ac00dd8a92a2$var$react_1.default.createElement("path", {
        fill: "currentColor",
        d: "M216,40H40A16,16,0,0,0,24,56V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40ZM205.66,85.66l-96,96a8,8,0,0,1-11.32,0l-40-40a8,8,0,0,1,11.32-11.32L104,164.69l90.34-90.35a8,8,0,0,1,11.32,11.32Z"
    }));
    return $b7c4ac00dd8a92a2$var$react_1.default.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "100%",
        height: "100%",
        viewBox: "0 0 32 32",
        fill: "none",
        "aria-hidden": true
    }, $b7c4ac00dd8a92a2$var$react_1.default.createElement("path", {
        d: "M27.7071 8.29389C28.0976 8.68442 28.0976 9.31758 27.7071 9.7081L13.7071 23.7075C13.3166 24.098 12.6834 24.098 12.2929 23.7075L5.29292 16.7081C4.90238 16.3176 4.90235 15.6844 5.29286 15.2939C5.68337 14.9034 6.31653 14.9033 6.70708 15.2938L13 21.5862L26.2929 8.29385C26.6834 7.90334 27.3166 7.90335 27.7071 8.29389Z",
        fill: "currentColor"
    }));
};
module.exports.Check = $b7c4ac00dd8a92a2$var$Check;

});


//# sourceMappingURL=check.9870480e.js.map
